const entity = 'event_locations'
const entitySingle = 'event_location'
const tableIcon = 'cil-location-pin'

export {
  entity,
  entitySingle,
  tableIcon
}
